import { EventEmitter } from '@angular/core';
import { VariableUtil } from '../../../utils/variable-util';
import { VariableDefinition } from '../../../communication/variable/variable-definition';
export class ConditionItemObserver {
    constructor(condition, variableStore) {
        this.condition = condition;
        this.variableStore = variableStore;
        this.conditionEffectiveChanged = new EventEmitter();
    }
    get variableName() {
        const variable = new VariableDefinition(this.condition.variableName, this.condition.variableGroupName, this.condition.dataSourceCode, this.condition.variableVersion);
        return VariableUtil.getConvertedVariableName(this.variableStore, variable);
    }
}
